// Sidebar.js
import React from 'react';
import Toggle from './ToggleMode';
import logo from './davannis_logo.png';

const Sidebar = ({
    activeComponent,
    setActiveComponent,
    stores,
    selectedStore,
    setSelectedStore,
    currentUser,
    onLogout
}) => {
    return (
        <div className="sidebar">
            <img className="logo" src={logo} />

            {stores.length > 1 ? (
                <select
                    className="store-select"
                    value={selectedStore}
                    onChange={(e) => setSelectedStore(e.target.value)}
                >
                    {stores.map(store => (
                        <option key={store._id} value={store._id}>{store.name}</option>
                    ))}
                </select>
            ) : (
                <h1>{stores[0]?.name || ''}</h1>
            )}

            <h2>Scheduler</h2>

            <ul>
                <li
                    className={activeComponent === 'employeeList' ? 'line-button active' : ''}
                    onClick={() => setActiveComponent('employeeList')}
                >
                    Employees
                </li>
                <li
                    className={activeComponent === 'ScheduleBuilder' ? 'line-button active' : ''}
                    onClick={() => setActiveComponent('ScheduleBuilder')}
                >
                    Schedule
                </li>
                 {currentUser?.role === 'admin' && (
                    <li
                        className={activeComponent === 'admin' ? 'line-button active' : ''}
                        onClick={() => setActiveComponent('admin')}
                    >
                        Admin
                    </li>
                )}


            </ul>
            <div className="sidebar-bottom">
             <Toggle />
                <div className="sidebar-user">
                    <span>{currentUser?.name || currentUser?.email}</span>
                    <button className="wide" onClick={onLogout}>Sign out</button>
                </div>
             </div>  

        </div>
    );
};

export default Sidebar;